import { Assignments } from "./Assignments";
import { Groups } from "./Groups";

const PREFIX = "TrackDashboardPage";

const classes = {
	root: `${PREFIX}-root`,
};

export const TrackDashboardPage = (): JSX.Element => {
	return (
		<div className={classes.root}>
			<Groups />
			<Assignments />
		</div>
	);
};
